module.exports = __webpack_public_path__ + "media/images/emblems/Isone-coat_of_arms-f9a6ec3e554755d8d76761bc5c72e0cf.svg";